"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ViewWithImageBackground_1 = __importDefault(require("../../../ViewWithImageBackground"));
const ControlRendererContext_1 = __importDefault(require("../../../../../ControlRendererContext"));
const shared_1 = require("../../../../../shared");
const BottomMenuSheetRendererWrapper = ({ control, style, children, }) => {
    const { Render, wrappers: { renderChildrenWrapper }, } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const childrenWrapperStyle = (0, react_1.useMemo)(() => ({ width: '100%', height: '100%' }), []);
    const bottomMenuSheetStyle = (0, react_1.useMemo)(() => {
        const computedStyle = {
            flexDirection: style.flexDirection || 'column',
            justifyContent: style.justifyContent,
            alignItems: style.alignItems,
            backgroundColor: style.background,
            width: '100%',
            flex: 1,
            height: '100%',
        };
        (0, shared_1.copyPropsIfDefined)(style, computedStyle, ['paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop']);
        return computedStyle;
    }, [style]);
    const mainWrapperStyle = (0, react_1.useMemo)(() => {
        const computedStyle = Object.assign(Object.assign({}, style), { position: 'absolute', bottom: 0, height: '100%' });
        return computedStyle;
    }, [style]);
    const withChildrenWrapperStyle = renderChildrenWrapper
        ? childrenWrapperStyle : bottomMenuSheetStyle;
    const formatedChildren = renderChildrenWrapper
        ? renderChildrenWrapper({
            control,
            style: bottomMenuSheetStyle,
            children,
        })
        : children;
    return (react_1.default.createElement(Render.View, { style: mainWrapperStyle },
        react_1.default.createElement(ViewWithImageBackground_1.default, { style: withChildrenWrapperStyle, resizeMode: control.resizeMode || undefined, backgroundImage: control.backgroundImage }, formatedChildren)));
};
exports.default = BottomMenuSheetRendererWrapper;
